<div class="col-12 p-3" *ngIf="Value">
    <div class="item-box" *ngFor="let item of Value.inputData">
        <div class="parent-box d-flex justify-content-start align-items-center">
            <!-- Leyer One -->
            <button type="button" class="tree-button p-0 mx-2" (click)="openParent(item)">
                <i class="fas" [ngClass]="{
                    'fa-angle-down' : item.isOpen,
                    'fa-angle-right' : !item.isOpen,
                    'disable-change' : !item.childrens
                }"></i>
            </button>
            <input type="checkbox" class="form-check-input tree-checkbox" [indeterminate]="item.isIndeterminate"
                [checked]="item.isEnable" (change)="changeCheckBox(item)" [(ngModel)]="item.isEnable"
                *ngIf="!item.stateEdit && Value.checkable">

            <span class="ms-1" *ngIf="!item.stateEdit && !Value.translateable">
                {{ item.viewName}}
            </span>
            <span class="ms-1" *ngIf="!item.stateEdit && Value.translateable">
                {{ item.viewName | translate}}
            </span>
            <input type="text" class="form-control treeview-title ms-1" *ngIf="item.stateEdit"
                [(ngModel)]="item.viewName">
            <div class="action-box mx-2">
                <button type="button" class="tree-button-add p-0" *ngIf="!item.stateEdit && Value.editable"
                    (click)="addItem(item)">
                    <i class="fa fa-plus"></i>
                </button>
                <button type="button" class="tree-button-edit p-0 mx-1" (click)="item.stateEdit=true"
                    *ngIf="!item.stateEdit && Value.editable">
                    <i class="fa-solid fa-pencil"></i>
                </button>
                <button type="button" class="tree-button-edit p-0 mx-1" (click)="item.stateEdit=false"
                    *ngIf="item.stateEdit">
                    <i class="fa fa-save"></i>
                </button>
                <button type="button" class="tree-button-delete p-0" *ngIf="Value.deleteable" (click)="deleteItem(item)">
                    <i class="fa-regular fa-trash-can"></i>
                </button>
            </div>
            <!-- Leyer One -->
        </div>
        <div class="child-item-box fade" *ngIf="item.childrens&&item.isOpen"
            [ngClass]="{'show': item.isOpen,'hide': !item.isOpen,}">
            <div class="item-box" *ngFor="let child of item.childrens">
                <div class="parent-box d-flex justify-content-start align-items-center">
                    <!-- Leyer Two -->

                    <button type="button" class="tree-button p-0 mx-2" (click)="openParent(child)">
                        <i class="fas" [ngClass]="{
                            'fa-angle-down' : child.isOpen,
                            'fa-angle-right' : !child.isOpen,
                            'disable-change' : !child.childrens
                            }"></i>
                    </button>
                    <input type="checkbox" class="form-check-input tree-checkbox"
                        [indeterminate]="child.isIndeterminate" [checked]="child.isEnable"
                        (change)="changeCheckBox(child,item)" [(ngModel)]="child.isEnable" *ngIf="!child.stateEdit && Value.checkable">

                    <span class="ms-1" *ngIf="!child.stateEdit && !Value.translateable">
                        {{ child.viewName}}
                    </span>
                    <span class="ms-1" *ngIf="!child.stateEdit && Value.translateable">
                        {{ child.viewName | translate }}
                    </span>
                    <input type="text" class="form-control treeview-title ms-1" *ngIf="child.stateEdit"
                        [(ngModel)]="child.viewName">
                    <div class="action-box mx-2">
                        <button type="button" class="tree-button-add p-0" *ngIf="!child.stateEdit && Value.editable"
                            (click)="addItem(child)">
                            <i class="fa fa-plus"></i>
                        </button>
                        <button type="button" class="tree-button-edit p-0 mx-1" (click)="child.stateEdit=true"
                            *ngIf="!child.stateEdit && Value.editable">
                            <i class="fa-solid fa-pencil"></i>
                        </button>
                        <button type="button" class="tree-button-edit p-0 mx-1" (click)="child.stateEdit=false"
                            *ngIf="child.stateEdit">
                            <i class="fa fa-save"></i>
                        </button>
                        <button type="button" class="tree-button-delete p-0" *ngIf="Value.deleteable"
                            (click)="deleteItem(child,item)">
                            <i class="fa-regular fa-trash-can"></i>
                        </button>
                    </div>
                    <!-- Leyer Two -->
                </div>
                <div class="child-item-box fade" *ngIf="child.childrens&&child.isOpen"
                    [ngClass]="{'show': child.isOpen,'hide': !child.isOpen,}">
                    <div class="item-box" *ngFor="let grandChild of child.childrens">
                        <div class="parent-box d-flex justify-content-start align-items-center">
                            <!-- Leyer Three -->

                            <button type="button" class="tree-button p-0 mx-2" (click)="openParent(grandChild)">
                                <i class="fas" [ngClass]="{
                                    'fa-angle-down' : grandChild.isOpen,
                                    'fa-angle-right' : !grandChild.isOpen,
                                    'disable-change' : !grandChild.childrens
                                    }"></i>
                            </button>
                            <input type="checkbox" class="form-check-input tree-checkbox"
                                [indeterminate]="grandChild.isIndeterminate" [checked]="grandChild.isEnable"
                                (change)="changeCheckBox(grandChild,child,item)" [(ngModel)]="grandChild.isEnable"
                                *ngIf="!grandChild.stateEdit && Value.checkable">

                            <span class="ms-1" *ngIf="!grandChild.stateEdit && !Value.translateable">
                                {{ grandChild.viewName}}
                            </span>

                            <span class="ms-1" *ngIf="!grandChild.stateEdit && Value.translateable">
                                {{ grandChild.viewName | translate}}
                            </span>
                            <input type="text" class="form-control treeview-title ms-1" *ngIf="grandChild.stateEdit"
                                [(ngModel)]="grandChild.viewName">
                            <div class="action-box mx-2">
                                <button type="button" class="tree-button-edit p-0 mx-1"
                                    (click)="grandChild.stateEdit=true" *ngIf="!grandChild.stateEdit && Value.editable">
                                    <i class="fa-solid fa-pencil"></i>
                                </button>
                                <button type="button" class="tree-button-edit p-0 mx-1"
                                    (click)="grandChild.stateEdit=false" *ngIf="grandChild.stateEdit">
                                    <i class="fa fa-save"></i>
                                </button>
                                <button type="button" class="tree-button-delete p-0"
                                    (click)="deleteItem(grandChild,child)" *ngIf="Value.deleteable">
                                    <i class="fa-regular fa-trash-can"></i>
                                </button>
                            </div>
                            <!-- Leyer Three -->
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
    <div class="item-box" *ngIf="Value.editable">
        <div class="parent-box d-flex justify-content-start align-items-center">

            <button type="button" class="tree-button treeview-add p-0 mx-2">
                <i class="fas fa-angle-right"></i>
            </button>

            <span class="ms-1">
                New Item
            </span>

            <button type="button" class="treeview-add-button" (click)="addItem()">
                <i class="fa fa-plus"></i>
            </button>
        </div>
    </div>
</div>

